import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './fade.styles.css';

class FadeTransparentComponent extends Component {
    render() {
        return (
            <div className={"mv-fade-container transparent" + (this.props.visible ? " visible" : "")}>
                <svg width="100px" height="100px">
                    <g transform="translate(25 50)">
                        <circle cx="0" cy="0" r="6" fill="#000" transform="scale(0.916798 0.916798)">
                            <animateTransform attributeName="transform" type="scale"
                                begin="-0.3333333333333333s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                                keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                        </circle>
                    </g>
                    <g transform="translate(50 50)">
                        <circle cx="0" cy="0" r="6" fill="#000" transform="scale(0.919034 0.919034)">
                            <animateTransform attributeName="transform" type="scale"
                                begin="-0.16666666666666666s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                                keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                        </circle>
                    </g>
                    <g transform="translate(75 50)">
                        <circle cx="0" cy="0" r="6" fill="#000" transform="scale(0.501811 0.501811)">
                            <animateTransform attributeName="transform" type="scale"
                                begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                                keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                        </circle>
                    </g>
                </svg>
            </div>
        )
    }
}

FadeTransparentComponent.propTypes = {
    visible: PropTypes.bool.isRequired
}

FadeTransparentComponent.defaultProps = {
    visible: false
}

export default FadeTransparentComponent;


// WEBPACK FOOTER //
// ./src/componentes/fade/fade.transparent.component.js